import React from 'react';

const TypingIndicator = ({ userName }) => {
  return (
    <div className='d-flex align-items-center gap-2 p-2 mb-2'>
      <div
        className='rounded-circle bg-primary d-flex align-items-center justify-content-center'
        style={{ width: 32, height: 32 }}
      >
        <span className='text-white fw-bold small'>
          {userName?.charAt(0).toUpperCase() || 'U'}
        </span>
      </div>
      <div className='bg-light rounded p-2 px-3'>
        <div className='d-flex align-items-center gap-1'>
          <div
            className='rounded-circle bg-secondary'
            style={{
              width: 6,
              height: 6,
              animation: 'bounce 1.4s infinite ease-in-out both',
              animationDelay: '0s',
            }}
          ></div>
          <div
            className='rounded-circle bg-secondary'
            style={{
              width: 6,
              height: 6,
              animation: 'bounce 1.4s infinite ease-in-out both',
              animationDelay: '0.2s',
            }}
          ></div>
          <div
            className='rounded-circle bg-secondary'
            style={{
              width: 6,
              height: 6,
              animation: 'bounce 1.4s infinite ease-in-out both',
              animationDelay: '0.4s',
            }}
          ></div>
        </div>
        <style>
          {`
            @keyframes bounce {
              0%, 80%, 100% {
                transform: scale(0);
                opacity: 0.5;
              }
              40% {
                transform: scale(1);
                opacity: 1;
              }
            }
          `}
        </style>
      </div>
      <span className='text-muted small'>
        {userName || 'User'} is typing...
      </span>
    </div>
  );
};

export default TypingIndicator;
